export default __webpack_public_path__ + "static/media/wifiIcon.b1e0e333.svg";